import { useDrop as useDndDrop } from "react-dnd";
import type { Identifier, XYCoord } from "dnd-core";
interface UseDropProps {
  index: number;
  moveType: string;
  ref: React.RefObject<HTMLElement>;
  moveRow: (dragIndex: number, hoverIndex: number) => void;
}

interface DragItem {
  index: number;
  id: string;
  type: string;
}

export default function useDrop({
  ref,
  index,
  moveType,
  moveRow,
}: UseDropProps) {
  const [{ handlerId }, drop] = useDndDrop<
    DragItem,
    void,
    { handlerId: Identifier | null }
  >({
    accept: moveType,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    // Move on hover
    hover(item: DragItem, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveRow(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  return { handlerId, drop };
}
